import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTableModule } from '@angular/material/table'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { ContractItemService } from '../../../../core/services/contract/contract-item/contract-item.service'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { ServiceOrderService } from '../../../../core/services/service/service-order/service-order.service'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: 'itinerary-service-order-edit',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
    MatTableModule,
    NgxMaskDirective,
    MatSlideToggleModule,
    MatDividerModule
  ],
  templateUrl: './itinerary-edit.component.html',
  styleUrl: './itinerary-edit.component.scss',
  providers: [DocumentTypeService, ViaCepService, provideNgxMask({
    dropSpecialCharacters: false
  })],
  standalone: true,
})
export class ItineraryEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private documentTypeService: DocumentTypeService,
    private addressTypeService: AddressTypeService,
    private viaCepService: ViaCepService,
    private snackbar: SnackbarCustomService,
    private contractItemService: ContractItemService,
    private itinerariesService: ItinerariesService,
    private ordemService: ServiceOrderService,
  ) { }



  private _form!: FormGroup
  public get form(): FormGroup {
    return this._form
  }
  public set form(value: FormGroup) {
    this._form = value
  }
  itemsList: any[] = [];
  @Output() response = new EventEmitter<any>()
  @Input() editItem: any = {}
  @Input() idItemContract = -1
  @Input() idItemPropose = -1
  listType: any[] = []
  documentTypeList: any[] = []
  itineraryList: any[] = []
  loading = false;
  areaTarifarioValue: any = false;
  hasChanges: any = false
  originalData: any = {}



  editIndex: number | null = null;
  editAgendaItem: any = null;
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  cepMask = '00000-000';


  columns: any[] = [
    { keyColumn: 'localParada', key: 'localParada', description: 'Local' },
    { keyColumn: 'cep', key: 'cep', description: 'Cep' },
    { keyColumn: 'logradouro', key: 'logradouro', description: 'Logradouro' },
    { keyColumn: 'numero', key: 'numero', description: 'Número' },
    { keyColumn: 'bairro', key: 'bairro', description: 'Bairro' },
    { keyColumn: 'cidade', key: 'cidade', description: 'Cidade' },
    { keyColumn: 'areaTarifario', key: 'areaTarifario', description: 'Área Tarifario' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ];

  displayedColumns = this.columns.map((col) => col.keyColumn);


  ngOnInit(): void {
    this.listTypeAddress()
    this.createForm()

    this.fillFormWithData(this.data.item);
  }


  fillFormWithData(item: any): void {
    this.form.patchValue({
      local: item.localParada || '',
      postalCode: item.cep || '',
      street: item.logradouro || '',
      state: item.estado || '',
      number: item.numero || '',
      neighborhood: item.bairro || '',
      city: item.cidade || '',
      country: 'Brasil',
      latitude: item.latitude || '',
      longitude: item.longitude || '',
      areaTarifario: item.areaTarifario === 'S' ? true : false
    })
    if (item.areaTarifario === 'S') this.areaTarifarioValue = true
  }

  onAreaTarifarioChange(event: any) {
    this.areaTarifarioValue = event.checked;
    this.form.patchValue({
      areaTarifario: event.checked ? 'S' : 'N'
    });
  }

  getItemProposeId(): void {
    this.loading = true;
    this.contractItemService.getContractItembyId(this.idItemContract).subscribe({
      next: (res) => {
        this.idItemPropose = res.data.itemPropostaId;
        this.listItineraries();
      },
      error: (err) => {
        console.error('Erro ao obter itemPropostaId', err);
        this.loading = false;
      }
    });
  }

  listItineraries(): void {
    this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data || [];
          this.numberRows = this.itemsList.length;
          this.loading = false;
        },
        error: (err) => {
          console.error('Erro ao listar itinerários', err);
          this.itemsList = [];
          this.loading = false;
        }
      });
  }


  handleTableResponse(event: any) {
    this.itemsList = event;
  }

  listTypeAddress() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  getAddressByPostalCode(): void {
    const postalCode = this.form.get('postalCode')?.value;
    if (postalCode && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (res) => this.fillFormViaCep(res),
        error: (err) => console.error('Erro ao buscar endereço', err)
      });
    }
  }


  fillForm() {
    this.form.get('addressType')?.setValue(this.editItem.tipo_endereco_id)
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
    this.form.get('latitude')?.setValue(this.editItem.latitude)
    this.form.get('longitude')?.setValue(this.editItem.longitude)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  getDocumentTypes() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (res) => {
        this.documentTypeList = res.data; // Use the correct property that contains the array
      },
      error: (err) => {
        // trate o erro se necessário
        this.documentTypeList = [];
      }
    });
  }

  closeModal() {
    this.dialog.getDialogById('itinerary-service-order-edit')?.close();
  }

  listPagedItinerary() {
    this.loading = true;
    this.ordemService.getServiceOrderItineraryStopbyId(this.idItemPropose, this.rows, this.page)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data ?? [];
          this.numberRows = this.itemsList.length;
          this.loading = false;
        },
        error: (err) => {
          this.itemsList = [];
          this.numberRows = 0;
          this.loading = false;
          console.error("Erro ao buscar itinerários:", err);
        }
      });
  }


  searchItineraryById(item: any) {

    this.itinerariesService.getItinerariesbyId(item).subscribe({
      next: (res) => {
      },
      error: (err) => {
      }
    })
  }

  searchItinerary() {
    this.loading = true;
    this.contractItemService.getContractItembyId(this.idItemContract)
      .subscribe({
        next: (res) => {
          this.idItemPropose = res.data.itemPropostaId;
          this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
            .subscribe({
              next: (res) => {
                this.treatResponse(res)
              },
              error: (err) => {
                this.loading = false;
                this.itineraryList = []
              }
            })
        },
        error: (err) => {
        }

      })
  }


  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }



  createForm(): void {
    this.form = this.formBuilder.group({
      local: [''],
      postalCode: ['', [Validators.required]],
      street: [''],
      state: [''],
      number: [''],
      neighborhood: [''],
      city: [''],
      country: ['Brasil'],
      latitude: [''],
      longitude: [''],
      areaTarifario: [''],
    })
  }

  getAddressTypeDescription() {
    const addressTypeId = this.form.get('addressType')?.value
    if (addressTypeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === addressTypeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createAddress() {

    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const item = this.form.value;
    this.response.emit(item);
    this.form.reset();
  }





  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {


        local: this.form.controls['local'].value ?? '',
        tipo_endereco: this.getAddressTypeDescription(),
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    } else {
      return {


        local: this.form.controls['local'].value ?? '',
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    }
  }


  editAddress() {
    const originalItem = this.data.item;

    const updatedItem = {
      id: originalItem.id,
      ordemServicoId: originalItem.ordemServicoId,
      localParada: this.form.value.local || originalItem.localParada,
      cep: this.form.value.postalCode || originalItem.cep,
      logradouro: this.form.value.street || originalItem.logradouro,
      numero: this.form.value.number || originalItem.numero,
      bairro: this.form.value.neighborhood || originalItem.bairro,
      complemento: originalItem.complemento || '',
      cidade: this.form.value.city || originalItem.cidade,
      estado: this.form.value.state || originalItem.estado,
      latitude: this.form.value.latitude ? Number(this.form.value.latitude) : originalItem.latitude || 0,
      longitude: this.form.value.longitude ? Number(this.form.value.longitude) : originalItem.longitude || 0,
      dataCriacao: originalItem.dataCriacao,
      horaCriacao: originalItem.horaCriacao,
      criadoPor: originalItem.criadoPor,
      trecho: originalItem.trecho || 'P',
      areaTarifario: this.form.value.areaTarifario || originalItem.areaTarifario == true ? 'S' : 'N',
      pais: this.form.value.country || originalItem.pais || 'Brasil'
    };

    this.loading = true;

    this.ordemService.editServiceOrderItinerary(updatedItem).subscribe({
      next: (res) => {
        this.loading = false;
        this.snackbar.success(res.message)
        // Fecha o modal e envia os dados atualizados
        this.dialog.getDialogById('itinerary-service-order-edit')?.close({
          success: true,
          updatedItem: updatedItem
        });
      },
      error: (err) => {
        this.loading = false;
        this.snackbar.error(err.message)
        this.dialog.getDialogById('itinerary-service-order-edit')?.close({
          success: false,
          error: err
        });
      }
    });
  }



  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(i => i.id !== item.id);
  }




}
